export var Category;
(function (Category) {
    /**企业 */
    Category[Category["Comp"] = 18] = "Comp";
    /**部门 */
    Category[Category["Dep"] = 19] = "Dep";
    /**用户 */
    Category[Category["User"] = 20] = "User";
    /**消息记录 */
    Category[Category["IMMessage"] = 50] = "IMMessage";
    /**群组 */
    Category[Category["IMGroup"] = 52] = "IMGroup";
    /**群组成员 */
    Category[Category["IMGroupUser"] = 53] = "IMGroupUser";
    /**群通知 */
    Category[Category["IMGroupNotice"] = 54] = "IMGroupNotice";
    /**好友 */
    Category[Category["IMFriends"] = 55] = "IMFriends";
    /**项目 */
    Category[Category["Project"] = 101] = "Project";
    /**项目目录 */
    Category[Category["ProjectDir"] = 103] = "ProjectDir";
    /**产品  原图纸） */
    Category[Category["Drawing"] = 104] = "Drawing";
    /**标准件 */
    Category[Category["Part"] = 105] = "Part";
    /**产品目录 */
    Category[Category["DrawingDir"] = 2104] = "DrawingDir";
    /**资料 */
    Category[Category["Document"] = 110] = "Document";
    /**资料目录 */
    Category[Category["DocumentDir"] = 2110] = "DocumentDir";
    /**通讯录 */
    Category[Category["Contact"] = 119] = "Contact";
    /**资源库 */
    Category[Category["Enterprise"] = 130] = "Enterprise";
    /**资源目录 */
    Category[Category["EnterpriseDir"] = 2130] = "EnterpriseDir";
    /**我的资源企业共享 */
    Category[Category["EnterpriseShare"] = 3130] = "EnterpriseShare";
    /**我的资源企业共享 */
    Category[Category["EnterpriseDirShare"] = 3130] = "EnterpriseDirShare";
    /**产品选型参数收藏 */
    Category[Category["LectoFavoriteDir"] = 2131] = "LectoFavoriteDir";
    /**产品选型参数收藏企业共享 */
    Category[Category["LectoFavoriteDirShare"] = 3131] = "LectoFavoriteDirShare";
    /**开放资源收藏 */
    Category[Category["ResourceFavoriteDir"] = 2135] = "ResourceFavoriteDir";
    /**开放资源收藏企业共享 */
    Category[Category["ResourceFavoriteDirShare"] = 3135] = "ResourceFavoriteDirShare";
    /**供应商 */
    Category[Category["Supplier"] = 131] = "Supplier";
    /**供应商目录 */
    Category[Category["SupplierDir"] = 132] = "SupplierDir";
    /**服务商 */
    Category[Category["Service"] = 134] = "Service";
    /**服务商目录 */
    Category[Category["ServiceDir"] = 135] = "ServiceDir";
    /**外协厂 */
    Category[Category["Outsourcing"] = 137] = "Outsourcing";
    /**外协厂目录 */
    Category[Category["OutsourcingDir"] = 138] = "OutsourcingDir";
    /**外协厂 */
    Category[Category["OutSource"] = 136] = "OutSource";
    /**外协厂目录 */
    Category[Category["OutSourceDir"] = 2136] = "OutSourceDir";
    /**外协厂目录企业共享 */
    Category[Category["OutSourceDirShare"] = 3136] = "OutSourceDirShare";
    /**产品 */
    Category[Category["Prod"] = 260] = "Prod";
    /**产品管理 */
    Category[Category["ProdDir"] = 264] = "ProdDir";
    /**插件 */
    Category[Category["Tools"] = 300] = "Tools";
    /**产品收藏 */
    Category[Category["ProdFavorite"] = 205] = "ProdFavorite";
    /**产品收藏目录 */
    Category[Category["ProdFavoriteDir"] = 2205] = "ProdFavoriteDir";
    /**企业新闻 */
    Category[Category["News"] = 27] = "News";
    /**企业新闻目录 */
    Category[Category["NewsDir"] = 2027] = "NewsDir";
    /**企业资质 */
    Category[Category["Certificate"] = 28] = "Certificate";
    /**企业资质 目录 */
    Category[Category["CertificateDir"] = 2028] = "CertificateDir";
    /**企业图片 */
    Category[Category["CompPic"] = 30] = "CompPic";
    /**企业图片 */
    Category[Category["Directory"] = 6] = "Directory";
    /**工作站下载 */
    Category[Category["WorkStation"] = 171] = "WorkStation";
    /**专用选型版本申请 */
    Category[Category["SpecialEdition"] = 172] = "SpecialEdition";
    /**本地化申请 */
    Category[Category["PrivateCloud"] = 173] = "PrivateCloud";
    /** 私有模型 */
    Category[Category["Model"] = 140] = "Model";
})(Category || (Category = {}));
export const CategoryName = {
    '18': "企业",
    '19': "部门",
    '20': "用户",
    '50': "消息记录",
    '52': "群组",
    "53": "群组成员",
    "54": "群通知",
    '260': "产品",
    '119': "联系人",
    '120': "通讯录",
    '300': "插件",
    '104': "图纸",
    '105': "零件",
    '110': "资料",
    '130': "资源",
    '101': "项目"
};
export var ShareArea;
(function (ShareArea) {
    ShareArea[ShareArea["self"] = 1] = "self";
    ShareArea[ShareArea["dep"] = 2] = "dep";
    ShareArea[ShareArea["depAndSub"] = 3] = "depAndSub";
    ShareArea[ShareArea["comp"] = 4] = "comp";
})(ShareArea || (ShareArea = {}));
export const CategoryTitle = {
    Project: "项目",
    Drawing: "图纸库",
    Product: "产品",
    Part: "私有模型库",
    Document: "资料库"
};
export const AdvertsType = {
    /**大搜索首页广告位 */
    HomeSwiper: 1,
    /**供应链推荐金牌供应商广告位 */
    GoldRecommend: 2,
    /**通用件分类企业图片广告位 */
    ClassComp: 3,
    /**通用件分类产品推广广告位 */
    ClassProduct: 4,
    /**大搜索关键词企业图片广告位 */
    SearchComp: 5,
    /**大搜索关键词产品推广广告位 */
    SearchProduct: 6,
    /**关键词搜索权重整体升级 */
    KeyWordsElevate: 7,
};
export const VipLevelValue = {
    '金牌': 32,
    '银牌': 4,
    '铜牌': 2,
    '仅认证': 0,
};
